export { default } from './PolicyAgreementModal';




// WEBPACK FOOTER //
// ./src/components/PolicyAgreementModal/index.jsx